import React, { useEffect, useState,useRef } from "react";
import SelectInput from "../forms/utils/selectinput";
import InputField from "../forms/utils/inputfield";
import Button from "../forms/utils/formbutton";
import { Constants } from "../../helpers/constants";
import useIsMobile from "../../hooks/useIsMobile";
import Loader from "../Loader/Loader";
import SearchableDropdown from "./searcheableDropdown";
import PageTitle from "./../PageTitle";
import {formatCurrency ,IsValidPrice} from "../../utils/GenUtils"
import Head from "next/head";
import { UPDATE_LOB_VALUE } from "../../redux/ActionTypes";
import { useRouter } from "next/router";
import Image from "next/image";
import { toggleForm } from "../../redux/ActionCreator"
import LinkButton from "../button";
// import testDriveIcon from "../../public/assets/images/testdrive.svg"; 
// import quoteReqIcon from "../../public/assets/images/quotereq.svg"; 
// import brochureDarkIcon from "../../public/assets/images/brochureDark.svg"; 
import { configuration } from "../../helpers/config";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";

 

const EmiCalculator = () => {


  const router = useRouter();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({
      type: UPDATE_LOB_VALUE,
      payload:configuration.COMMON_MASTER_LOB,
    });
  }, []);


  const { modelname, modelcode } = router.query;
console.log(modelcode,modelname,"wwwwwww11")
  const [cityinfo, setcityinfo] = useState([]);
  const [emidata, setemidata] = useState([]);
  const [selectedCity, setselectedCity] = useState();
  const [loading, setloading] = useState(true);
  const [modelData, setModelData] = useState([]);
  const [variants, setVariants] = useState([]);
  const [vechileCharges, setVechileCharges] = useState(0);
  const [DownpaymentCharges, setDownpaymentCharges] = useState(0);
  const [selectedVariant, setselectedVariant] = useState();
  const [selectedModel, setselectedModel] = useState();
  const [selectedMethods, setselectedMethods] = useState([]);
  const [selectedvechileCondition,setselectedvechileCondition] = useState([])
  const [cashCreditAmount, setcashCreditAmount] = useState(0);
  const [financeCreditAmount, setfincanceCreditAmount] = useState(0);
  const [roadtax, setroadtax] = useState(0);
  const [finalEmi,setFinalEmi] = useState();
  const [formsData,setFormsData]=useState()
  const [matchedModel, setMatchedModel] = useState(null);
  const [Modelloading,setModelloading] = useState(false)
  const ref = React.useRef(null);
  const emiRef = useRef(null);
  const reduxData = useSelector(({ app }) => app);

  const handleScrollToEmi = () => {
    emiRef.current?.scrollIntoView({ behavior: "smooth" });
  };
const LOB_VALUE = useSelector((state) => state?.app?.LobValue);

console.log(selectedvechileCondition,"qqqq")
  
  const [inputValue, setInputValue] = useState("--"); 
  const [errorMessage, setErrorMessage] = useState("");
  const [citydata, setcitydata] = useState([]);
  const [transformedData, setTransformedData] = useState([]);
const [transformedDataCopy, setTransformedDataCopy] = useState([]);
 
  const [EmiData, setEmiData] = useState()
console.log(EmiData,"uuu")

const [calculationData, setCaculationData] = useState({
  selectedDownpayment:0,
  selectedTenure:0,
  selectedInterest:0,
  modelPrice:"40000",
  PriceType: "",
  downpaymentAmount: 0,
  transformedDataCopy:[],
  transformedDataCopy1:[],
  selectVariant:{},
  downpayment: 0,
  selectedDownpaymenamount:0,
  defaultModel:"",
  defaultModelName:"",
  vechileTaxs:[],
  vehicleAdditionalCharge:[],
  downpaymentTax:[],
  downpaymentDefaultTax:[],
  City_to_be_shown: true,
  Interest_to_be_shown: false,
  isDownpaymentStatic: false,
  intrestRateProvided: false,
  vehiclePrice: 0,
  isDownpaymentCondition: false,
  taxdetails: [],
  downpaymentAdditionalChargeCondition: [],
  calculatedEmi: 0,
});

console.log(calculationData, "ddd")
useEffect(()=>{
  setroadtax(0)
  console.log("cash credirt",cashCreditAmount)
  console.log("finance credirt",financeCreditAmount)
  console.log("finance credirt 222",DownpaymentCharges)
  if(cashCreditAmount>0){
    setroadtax(cashCreditAmount*0.025*1.16)
  }
  else if(financeCreditAmount>0){
    setroadtax((financeCreditAmount+DownpaymentCharges+900)*0.025*1.16)
  }
},[cashCreditAmount,financeCreditAmount, DownpaymentCharges])

useEffect(() => {
  const sellingPrice = Number(calculationData?.selectVariant?.selling_price); // notice _ here
  const selectedDownpayment = Number(calculationData?.selectedDownpayment);

  if (!isNaN(sellingPrice) && !isNaN(selectedDownpayment)) {
    const downpaymentAmount = ((vechileCharges + sellingPrice) * selectedDownpayment) / 100;

    setCaculationData(prev => ({
      ...prev,
      downpaymentAmount,
    }));
  }
}, [
  calculationData.selectVariant?.selling_price, // depend on the actual selling_price
  calculationData.selectedDownpayment,
  vechileCharges
]);


const calculateEmi =  async(loanamount, loanTenureMonths, annualInterestRate) => {
  console.log("cc444",loanamount,loanTenureMonths,annualInterestRate)
  const monthlyInterestRate = annualInterestRate / 12 / 100;
  const totalInstallments = loanTenureMonths;
  const emi =
      (loanamount *
          monthlyInterestRate *
          Math.pow(1 + monthlyInterestRate, totalInstallments)) /
      (Math.pow(1 + monthlyInterestRate, totalInstallments) - 1);
  return emi
 
};


useEffect(() => {
  // Sync input when state updates externally
  setInputValue(calculationData?.downpaymentAmount?.toString());
}, [calculationData?.downpaymentAmount]);

  const mobile = useIsMobile();

  const handleScroll = (offset) => {
    if (ref.current) {
      ref.current.scrollLeft += offset;
    }
  };
// console.log(calculationData?.taxdetails,"hittttuuu")

  // Update selectVariant when transformedDataCopy changes
useEffect(() => {
  console.log(transformedDataCopy[0],"hitttt")
  setCaculationData(pre=>({
    ...pre,selectVariant:transformedDataCopy[0]
  }))

  if (calculationData?.transformedDataCopy?.length > 0) {
    setCaculationData(prevState => ({
      ...prevState,
      selectVariant: prevState.selectVariant?._id 
        ? prevState.selectVariant // Keep previous selection if exists
        : prevState.transformedDataCopy[0] // Select first item by default
    }));
  }
}, [calculationData.transformedDataCopy]);


  useEffect(() => {
    if (EmiData?.downpaymentDetails?.type!=="percentage" && EmiData?.downpaymentDetails?.amoutConfig?.defaultDownpayment && calculationData?.selectVariant?.selling_price) {
      const defaultDownpayment = EmiData.downpaymentDetails.amoutConfig.defaultDownpayment; // 44%
      const modelPrice = parseFloat(calculationData?.selectVariant?.selling_price); // 40000 as number
  
      const downpaymentAmount = (defaultDownpayment / 100) * (vechileCharges + modelPrice); // Calculate downpayment from given percentage
  
      setCaculationData((prev) => ({
        ...prev,
        selectedDownpaymenamount: defaultDownpayment, // Set percentage
        downpaymentAmount: downpaymentAmount, // Set calculated amount
      }));
    }
    if (EmiData?.downpaymentDetails?.type==="percentage" && EmiData?.downpaymentDetails?.percentageConfig?.defaultDownpayment && calculationData?.selectVariant?.selling_price) {
      const defaultDownpayment = EmiData.downpaymentDetails.percentageConfig.defaultDownpayment; // 44%
      const modelPrice = parseFloat(calculationData?.selectVariant?.selling_price); // 40000 as number
  
      const downpaymentAmount = (defaultDownpayment / 100) * (vechileCharges + modelPrice); // Calculate downpayment from given percentage
  
      setCaculationData((prev) => ({
        ...prev,
        selectedDownpaymenamount: defaultDownpayment, // Set percentage
        downpaymentAmount: downpaymentAmount, // Set calculated amount
      }));
    }
    
    
  }, [EmiData, calculationData?.selectVariant?.selling_price,vechileCharges]); 

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(`${configuration.APP_URL_CONTENTS}/emi-calculator`);
 
        setEmiData(res?.data[0]);
        
      } catch (error) {
        console.log("Error in API call", error);
      } finally {
      }
    })();
  }, []); // No dependency needed if it runs only once
 
  console.log(EmiData,"tumne")
  useEffect(() => {
    if (EmiData) {
      console.log((EmiData),"sss")
      setCaculationData((prev) => ({
        ...prev,
        selectedDownpayment: Number(EmiData?.downpaymentDetails?.percentageConfig?.defaultDownpayment),
        selectedDownpaymenamount: Number(EmiData?.downpaymentDetails?.amoutConfig?.defaultDownpayment),
        selectedTenure: EmiData?.tenureDetails?.defaultTenure,
        selectedInterest:
        !EmiData?.City_to_be_shown && !EmiData?.interestSelection?.showintrest
          ? EmiData?.interestSelection?.addressConfig?.[0]?.interestRate
          : EmiData?.City_to_be_shown && !EmiData?.interestSelection?.showintrest
          ? EmiData?.interestSelection?.addressConfig?.[0]?.interestRate
          : EmiData?.interestSelection?.intrestConfig?.defaultIntrest,
        // downpaymentAmount: EmiData?.defaultDownpayment 
        //   ? (EmiData?.modelPrice / 100) * (parseFloat(EmiData.defaultDownpayment))
        //   : prev.downpaymentAmount,
          defaultModel : modelcode?.toUpperCase() ? modelcode?.toUpperCase() : EmiData?.modelDetails?.defaultmodelCode,
          defaultModelName:modelname?.toUpperCase() || EmiData?.modelDetails?.defaultModel,
          vehicleAdditionalCharge:EmiData?.vehicleAdditionalCharge,
          downpaymentAdditionalCharge:EmiData?.downpaymentAdditionalCharge,
        // cityintreset : EmiData?.interestSelection?.addressConfig
        // minDownpayment: EmiData?.minDownpayment || prev.minDownpayment,
      }));
    }
    console.log(calculationData,"sss111")
  }, [EmiData]); // Runs whenever EmiData updates

// const transformVariants = (model_code, model_name,variants) => {
//   return variants.flatMap(variant => {
//     const colors = variant.colors && variant.colors.length > 0
//       ? variant.colors
//       : [{ color_name: null, color_code: null }]; // Default placeholder

//     return colors.map(color => ({
//       ...color,
//       model_code,
//       model_name,
//       variant_name: variant.variant_name,
//       variant_code: variant.variant_code
//     }));
//   });
// };

  // Function to transform variants into a structured format
const transformVariants = (model_code, model_name, variants) => {
  return variants.map(variant => ({
    ...variant,
    model_code,
    model_name,
  }));
}

// Update transformedData when selectedModel or variants change
useEffect(() => {
  const newData = transformVariants(calculationData?.defaultModel, calculationData?.defaultModelName,variants);
  console.log(calculationData?.defaultModel,variants,"llll999",newData)
  setTransformedData(newData);
  setCaculationData(prevState => ({
    ...prevState,
    transformedDataCopy: newData
  }));
}, [calculationData?.defaultModel, variants]);

const fetchSellingPricesForAllColors = async (data) => {
  try {
    setModelloading(true);

    const updatedData = [];

    for (const item of data) {
      try {
        const response = await axios.get(
          `${configuration.COMMON_MASTER_API}/sellingPrices?pageNumber=1&pageSize=10&lob=${configuration.COMMON_MASTER_LOB}&modelCode=${item.model_code}&variantCode=${item.variant_code}&status=true`,
          configuration.HEADER_DEALER_LOCATOR
        );

        const sellingPriceDetails = response.data?.data?.[0]?.sellingPriceDetails?.[0] || {};

        const priceKey = EmiData?.vehiclePrice?.toLowerCase().replace(/\s/g, '');
        const matchedPrice = sellingPriceDetails[priceKey] || null;

        const taxDetails = sellingPriceDetails?.taxChargeDetails || []; // ✅ Default to []

        updatedData.push({ ...item, selling_price: matchedPrice, taxChargeDetails: taxDetails });
      } catch (error) {
        console.error(`Error fetching price for ${item.color_name}:`, error.message);
        updatedData.push({ ...item, selling_price: null, taxChargeDetails: [] }); // ✅ Add empty taxChargeDetails even on error
      }
    }

    // ✅ Determine selectVariant
    let selectVariant = updatedData.find(
      (item) => item.variant_code === EmiData?.modelDetails?.defaultvarintcode
    );

    if (selectVariant) {
      const filteredData = updatedData.filter(item => item.variant_code !== selectVariant.variant_code);
      updatedData.length = 0;
      updatedData.push(selectVariant, ...filteredData);
    } else {
      selectVariant = updatedData
        .filter(item => item.selling_price !== null)
        .sort((a, b) => a.selling_price - b.selling_price)[0] || updatedData[0] || {};

      if (selectVariant && updatedData.length > 0 && updatedData[0] !== selectVariant) {
        const filteredData = updatedData.filter(item => item !== selectVariant);
        updatedData.length = 0;
        updatedData.push(selectVariant, ...filteredData);
      }
    }

    setCaculationData((prev) => ({
      ...prev,
      transformedDataCopy1: updatedData,
      selectVariant, // ✅ Already has taxChargeDetails (empty array if not available)
    }));
  } catch (error) {
    console.error("Error fetching selling prices:", error);
  } finally {
    setModelloading(false);
  }
};




// Call API when transformedData updates
useEffect(() => {
  if (transformedData?.length > 0) {
    fetchSellingPricesForAllColors(transformedData);
  }
  else{
    setCaculationData(prevState => ({
      ...prevState,
      transformedDataCopy1: transformedData,
    }));
  }
}, [transformedData]);
console.log(calculationData,"qqqwww")

  useEffect(() => {
    (async () => {
      try {
        // setloading(true);
        const res = await axios.get(`${configuration.APP_URL_PRODUCTS}model?lob=1`);
  console.log(res,"ccc")
        let data = res?.data?.data?.map((item) => {
          return { ...item };
        });
  console.log(data,"ccc1")
        setModelData(data);
        // setloading(false);
      } catch (error) {
        console.log("Error in API call", error);
        setloading(false);
      }
    })();
  }, []);
 

  // useEffect(() => {
  //   if (!configuration.API_LOB) return; 
  //   if (reduxData.dealerCode != "") {
  //     (async () => {
  //       try {
  //         const res = await axios.get(
  //           `${configuration.APP_URL_CONTENTS}/forms?lob=${configuration.API_LOB}&dealer_code=${reduxData.dealerCode}`
  //         );
  //         setFormsData(res.data[0]?.forms);
  //       } catch (e) {}
  //     })();
  //   }
  // }, [reduxData.dealerCode]);



  console.log(calculationData,"hhh")

// mached the price title from the model section
useEffect(() => {
  if (modelData?.length && calculationData?.defaultModel) {
    const match = modelData.find(
      (item) => item.model_code === calculationData?.defaultModel
    );
    if (match) {
      setMatchedModel(match);
    }
  }
}, [modelData,calculationData]);

  useEffect(() => {
    if (calculationData.selectedDownpayment) {
      const downpaymentPercentage = parseFloat(calculationData.selectedDownpayment);
     
      const downpaymentAmount = (downpaymentPercentage / 100) * (vechileCharges + calculationData?.selectVariant?.selling_price);
      console.log(downpaymentAmount,"yyy")
      setCaculationData((prev) => ({
        ...prev,
        downpaymentAmount, // Automatically update amount when selectedDownpayment changes
      }));
    }
  }, [calculationData.selectedDownpayment,vechileCharges])

  useEffect(() => {
    if (calculationData.selectedDownpaymenamount && EmiData?.downpaymentDetails?.type ==="amount") {
      const downpaymentPercentage = parseFloat(calculationData.selectedDownpaymenamount);
      const downpaymentAmount = (downpaymentPercentage / 100) * (vechileCharges + calculationData?.selectVariant?.selling_price);
      
      setCaculationData((prev) => ({
        ...prev,
        downpaymentAmount, // Automatically update amount when selectedDownpaymenamount changes
      }));
    }
  }, [calculationData.selectedDownpaymenamount,vechileCharges])


  useEffect(() => {
    (async () => {
      try {
        // setloading(true);
        
        // Call only the Address API
        const res2 = await axios.get(
          `${configuration.COMMON_MASTER_API}/address/${
            configuration.ADD_LEVEL
          }?status=true&countryCode=${configuration.COUNTRY_CODE}&lob=1&level${configuration.ADD_LEVEL - 1}`,
          configuration.HEADER_DEALER_LOCATOR
        );
        console.log(res2,"www")
        setcitydata(res2?.data?.data);
        // setloading(false);
      } catch (error) {
        console.log("Error in Address API call", error);
        // setloading(false);
      }
    })();
  }, [LOB_VALUE]);
  

   useEffect(() => {
      let addressLevel = "";
      let arr = [];
      if (configuration.ADD_LEVEL == 1) {
        addressLevel = "addressLevel1";
      } else if (configuration.ADD_LEVEL == 2) {
        addressLevel = "addressLevel2";
      } else if (configuration.ADD_LEVEL == 3) {
        addressLevel = "addressLevel3";
      } else if (configuration.ADD_LEVEL == 4) {
        addressLevel = "addressLevel4";
      }
 
      citydata && citydata.map((item)=>{
        arr.push(item?.[addressLevel])
      })
      arr.sort((a, b) => a.name.localeCompare(b.name));
      setcityinfo(arr)
      // setEmiData({...EmiData , cityinfo : arr})
    }, [citydata]);

//useeffect for getting interest rate in a specific address for a specific model
    useEffect(() => {
        //  if(EmiData?.interestSelection?.showintrest == true){
        //   setCaculationData({...calculationData,selectedInterest:EmiData?.interestSelection?.intrestConfig?.defaultIntrest})
        //  }
        if (!EmiData?.City_to_be_shown && EmiData?.interestSelection?.showintrest == false ) {
          calculationData?.defaultModel &&
          EmiData.interestSelection?.addressConfig?.map((item) => {
            if (item?.model?.modelCode == calculationData?.defaultModel) {
              setCaculationData({ ...calculationData, selectedInterest: item?.interestRate });
            }
            else {
              let fixedInterest = EmiData.interestSelection?.addressConfig?.filter(
                  (item) => item?.model?.modelCode == "All",
              );
              console.log(fixedInterest,"eee")
              setCaculationData({
                ...calculationData,
                selectedInterest: fixedInterest?.[0]?.interestRate,
              });
            }
          });
        }else if(EmiData?.interestSelection?.showintrest == true && EmiData?.City_to_be_shown){
          setCaculationData({...calculationData,selectedInterest:EmiData?.interestSelection?.intrestConfig?.defaultIntrest})
         }
        else{
          let addl = "";
          if (configuration.ADD_LEVEL == 1) {
            addl = "addressL1";
          } else if (configuration.ADD_LEVEL == 2) {
            addl = "addressL2";
          } else if (configuration.ADD_LEVEL == 3) {
            addl = "addressL3";
          } else if (configuration.ADD_LEVEL == 4) {
            addl = "addressL4";
          }
    
          calculationData?.defaultModel &&
          selectedCity &&
          EmiData.interestSelection?.addressConfig?.map((item) => {
            console.log(item ,"vvv11")
            if (
                item?.[addl] == selectedCity &&
                item?.model?.modelCode == calculationData?.defaultModel
            ) {
              setCaculationData({ ...calculationData, selectedInterest: item?.interestRate });
            } else if (
                item?.[addl] == "All" &&
                item?.model?.modelCode == calculationData?.defaultModel
            ) {
              setCaculationData({ ...calculationData, selectedInterest: item?.interestRate });
            } else if (item?.[addl] == "All" && item?.model?.modelCode == "All") {
              setCaculationData({ ...calculationData, selectedInterest: item?.interestRate });
            } else if (
                item?.[addl] == selectedCity &&
                item?.model?.modelCode == "All"
            ) {
              setCaculationData({ ...calculationData, selectedInterest: item?.interestRate });
            }
          });
        }
      }, [selectedCity,calculationData?.defaultModel]);
      

    useEffect(() => {

      if (modelData?.length > 0 && calculationData?.defaultModel) {
        const defaultModel = modelData.find(
          (model) => model.model_code === calculationData.defaultModel
        );
       console.log(defaultModel,"ggg")
        if (defaultModel) {

          setselectedModel(defaultModel.model_code);
          setVariants(defaultModel.variants || []);
        }
      }
    }, [modelData, calculationData?.defaultModel]);

console.log(calculationData?.defaultModel,"www")

console.log(selectedMethods,"aaaaa")
console.log(DownpaymentCharges,"aaaaa11")

 //useeffect for getting total of the charges and taxes applicable on vehicle price
 useEffect(() => {
  setVechileCharges(0);
  setDownpaymentCharges(0); 

  calculationData?.selectVariant?.taxChargeDetails &&
  calculationData?.selectVariant?.taxChargeDetails?.map((taxdata) => {
    if(!EmiData?.isvehicleAdditionalCondition){
    EmiData?.vehicleAdditionalCharge?.map((item) => {
      if (item?.type == taxdata?.taxChargeType) {
        taxdata?.valueType == 1
            ? setVechileCharges(
                (prev) =>
                    prev + (calculationData?.selectVariant?.selling_price * taxdata?.value) / 100,
            )
            : setVechileCharges((prev) => prev + taxdata?.value);
      }
    });
  }else{
    selectedvechileCondition.length > 0 &&
    selectedvechileCondition.forEach((method) => {
      method.value?.methodValue?.forEach((val) => {
        if (val?.type === taxdata?.taxChargeType) {
          if (taxdata?.valueType === 1) {
            setVechileCharges((prev) =>
              prev + (calculationData?.selectVariant?.selling_price * taxdata?.value) / 100
            );
          } else {
            setVechileCharges((prev) => prev + taxdata?.value);
          }
        }
      });
    });
  }
  });

  calculationData?.selectVariant?.taxChargeDetails &&
  calculationData?.selectVariant?.taxChargeDetails?.map((taxdata) => {
    if (!EmiData?.isDownpaymentCondition) {
      EmiData?.downpaymentAdditionalCharge?.map((item) => {
        if (item?.type == taxdata?.taxChargeType) {
          taxdata?.valueType == 1
              ? setDownpaymentCharges(
                  (prev) =>
                      prev + (calculationData?.selectVariant?.selling_price * taxdata?.value) / 100,
              )
              : setDownpaymentCharges((prev) => prev + taxdata?.value);
        }
      });
    } else {
      selectedMethods.length > 0 &&
      selectedMethods.forEach((method) => {
        method.value?.methodValue?.forEach((val) => {
          if (val?.type === taxdata?.taxChargeType) {
            if (taxdata?.valueType === 1) {
              setDownpaymentCharges((prev) =>
                prev + (calculationData?.selectVariant?.selling_price * taxdata?.value) / 100
              );
            } else {
              setDownpaymentCharges((prev) => prev + taxdata?.value);
            }
          }
        });
      });
    }
  });
}, [calculationData?.selectVariant?.selling_price, calculationData?.selectVariant?.taxChargeDetails, selectedMethods, selectedvechileCondition]);

console.log(formsData,"uuuu111")

useEffect(() => {
  if (reduxData.dealerCode != "") {
      (async () => {
        try {
          const res = await axios.get(
            `${configuration.APP_URL_CONTENTS}/forms?lob=${configuration.API_LOB}&dealer_code=${reduxData.dealerCode}`,
            configuration.HEADER_DEALER_LOCATOR_VAPT,
          );
         
          let requiredForm = res.data[0]?.forms
          console.log(requiredForm,"llll4444")
          setFormsData(requiredForm);
        } catch (e) {
          console.log(e.message);
        }
      })();
    }
}, [ ]);




console.log(finalEmi,"rrrr111")

// emi calculation======>
useEffect(() => {
  const calculate = async () => {
    console.log(
      cashCreditAmount,
      "cash",
      vechileCharges,
      "total",
      calculationData?.selectVariant?.selling_price,
      calculationData?.downpaymentAmount,
      calculationData?.selectedInterest
    );

    const principalAmount =
      vechileCharges +
      calculationData?.selectVariant?.selling_price -
      calculationData?.downpaymentAmount;

    if (process.env.NEXT_PUBLIC_COUNTRY_CODE === "MEX") {
      if (cashCreditAmount) {
        const pmt = await calculateEmi(
          principalAmount,
          calculationData?.selectedTenure,
          calculationData?.selectedInterest
        );
        console.log("oooo", pmt);
        setFinalEmi(pmt.toFixed(2));
      } else {
        const pmt = await calculateEmi(
          principalAmount,
          calculationData?.selectedTenure,
          calculationData?.selectedInterest
        );

        const pmt2 = await calculateEmi(
          DownpaymentCharges + 900,
          12,
          calculationData?.selectedInterest
        );

        console.log(pmt2, "ooo11", DownpaymentCharges, pmt, pmt + pmt2);
        setFinalEmi((pmt + pmt2).toFixed(2));
      }
    } else {
      const pmt = await calculateEmi(
        principalAmount,
        calculationData?.selectedTenure,
        calculationData?.selectedInterest
      );
      setFinalEmi(pmt.toFixed(2));
    }
  };

  calculate();
}, [
  calculationData?.selectVariant?.selling_price,
  calculationData?.downpaymentAmount,
  calculationData?.selectedInterest,
  calculationData?.selectedTenure,
  cashCreditAmount,
  vechileCharges,
  DownpaymentCharges
]);



useEffect(() => {
  console.log(inputValue,"inputValue",typeof(inputValue))
  if(inputValue === "0"){
    setInputValue("")
  }
},[inputValue])

  //  const CardLinkFunc = ({ cardBtnText, formToBeSelected }) => {
  //   console.log(formsData,formToBeSelected,"vvvvvv222")
  //     let form;
      
  //       form = formsData?.filter((item) => item?.form_name == formToBeSelected);
  //    console.log(formsData,form,"tttt1111")
  //     return (
  //       <>
             
  //             <LinkButton
  //               classname="button_dark_arrow"
  //               type={"primary_grad_button"}
  //               buttontext={cardBtnText}
  //               onClick={() => {
  //                 dispatch(toggleForm(form?.form_name));
  //               }}
  //             />
        
      
  //       </>
  //     );
  //   };
  

  return (
    <>
      {!loading ? (
        <Loader />
      ) : (
        <>
          <Head>
            <meta
              name="description"
              content={`${
                process.env.NEXT_PUBLIC_COUNTRY_CODE == "MEX"
                  ? "Utiliza la Calculadora EMI de Suzuki para planificar fácilmente tus opciones de financiamiento y encontrar las mejores soluciones de pago para tu auto soñado en México."
                  : ""
              }`}
            />
          </Head>

          <PageTitle
            title={`${
              process.env.NEXT_PUBLIC_COUNTRY_CODE == "MEX"
                ? "Calculadora EMI de Suzuki México | Soluciones de Financiamiento Fáciles para Tu Auto Soñado"
                : ""
            }`}
          />
          <div className="container-fluid mt-[60px]">
            {/* banner image section for emi calculator */}
          {/* <div className={`h-[547px] lg:h-[712px] w-[100%] object-cover"`}>
                <h1
                    className={`absolute flex items-end font-suzukiBold tracking-[1.2px] text-inverted h-[486px] ml-[30px] text-[30px] lg:h-[593px] lg:ml-[74px] lg:text-[60px]`}
                >
                  {Constants.EMICALCULATOR.TITLE}
                </h1>
                <img
                    className="w-[100%] h-[100%] object-cover"
                    src={
                      !mobile
                        ? `${configuration.IMG_STATIC_URL}assets/images/emi-desktop-banner.png`
                        : `${configuration.IMG_STATIC_URL}assets/images/emi-mobile-banner.png`
                    }
                    alt={Constants?.altTags?.EMI_CALCULATOR_BANNER || "EMI Calculator Banner Image"}
                />
              </div>  */}

            <div
              className="container mt-[100px] finanance_calculator"
             
            >
              <div className="text-left font-suzukiBold text-primary-blue text-heading pb-[50px] f-heading">
                {Constants.expericencIcon.FINANCE_CALCULATOR}
                {configuration?.COUNTRY_CODE=="MEX" && <>
                  <p className="text-xs text-gray-500 mt-2">
                 {Constants?.EMICALCULATOR?.LEGAL_DISCLAIMER? Constants?.EMICALCULATOR?.LEGAL_DISCLAIMER:"Aviso Legal: Los precios son indicativos y su aplicabilidad está sujeta a la fecha de facturación del vehículo.Para detalles específicos, puede visitar su concesionario más cercano.*Los cálculos son una simulación de mensualidades con cifras aproximadas."}
                  </p>
                  </>}
              </div>
              <div className="f-container">
                <div className="f-boxLeft">
                  <div class="f-boxForm">
                    <div className="mb-[25px]">
                      <SelectInput
                        id="selectedmodel"
                        style={{fontSize:"18px"}}
                        label={Constants.EMICALCULATOR.SELECT_MODEL}
                        items={modelData}
                        selectedModelCode={calculationData?.defaultModel}
                        placeholder={Constants.EMICALCULATOR.SELECT_MODEL}
                        onChange={(e) => {
                          const selected = JSON.parse(e.target.value);
                      
                          if (selected?.model_code) {
                            // ✅ Set defaultModel and reset dependent values
                            setCaculationData((prev) => ({
                              ...prev,
                              defaultModel: selected.model_code,
                              defaultModelName: selected.model_name,
                              selectedDownpayment: Number(EmiData?.downpaymentDetails?.percentageConfig?.defaultDownpayment),
                              selectedDownpaymenamount: Number(EmiData?.downpaymentDetails?.amoutConfig?.defaultDownpayment),
                              selectedTenure: EmiData?.tenureDetails?.defaultTenure,
                              selectedInterest:
                              !EmiData?.City_to_be_shown && !EmiData?.interestSelection?.showintrest
                                ? EmiData?.interestSelection?.addressConfig?.[0]?.interestRate
                                : EmiData?.City_to_be_shown && !EmiData?.interestSelection?.showintrest
                                ? EmiData?.interestSelection?.addressConfig?.[0]?.interestRate
                                : EmiData?.interestSelection?.intrestConfig?.defaultIntrest,

                            }));
                      
                            // ✅ Set variants based on selected model
                            setVariants(selected.variants || []);
                            
                            // ✅ Clear previously selected variant if needed
                            setselectedVariant("");
                          } else {
                            // ❌ Reset everything if nothing is selected
                            setCaculationData((prev) => ({
                              ...prev,
                              defaultModel: "",
                              // taxdetails: [],
                            }));
                            setVariants([]);
                            setselectedVariant("");
                          }
                          setErrorMessage("")
                        }}                    
                      />
                    </div>
                    <div className="mb-[25px] relative">
                      <label className="label-text">{Constants.EMICALCULATOR.SELECT_VARIANT}</label>
                      <div className="f-selectvariantWrapper" style={{ minHeight: "100px" }}> 
                      {Modelloading ? (
  <div className="f-loader">
    {/* Your loader component or spinner */}
    <Loader />
  </div>
) : (
  <div
  className={`f-selectvariant${calculationData?.transformedDataCopy1?.length > 3 ? ' scrollable' : ''}`} ref={ref}>
    {calculationData?.transformedDataCopy1?.map((item, index) => (
      <div
        key={item._id || index}
        className={
          item?._id === calculationData?.selectVariant?._id
            ? "f-selectvariantCard f-borderSelected"
            : "f-selectvariantCard f-border"
        }
        onClick={() =>{
          setCaculationData((prevState) => ({
            ...prevState,
            selectVariant: item,
          }))
           setErrorMessage("")
        }
        }
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            setCaculationData((prev) => ({
              ...prev,
              selectVariant: item,
            }));
          }
        }}
        onFocus={(e) => {
          e.currentTarget.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "center",
          });
        }}
      >
        <div className="f-check">
          <input
            type="checkbox"
            checked={item?._id === calculationData?.selectVariant?._id}
            name="name2"
            className="checkbox_round checkbox2"
            tabIndex={-1}
            readOnly
            aria-label="Select variant"
          />
        </div>
        <div className="f-carImg">
          <Image
            src={
          configuration.IMG_URL + 
          (item?.colors?.find((color) => color.is_default === true) || item?.colors?.[0])?.image
        }
            width={160}
            height={100}
            alt="model_variant"
          />
        </div>
        <h3 className="f-variantNam mb-4">{item?.variant_name}</h3>
        <p className="mb-0">
          {(EmiData?.vehiclePrice)?.toLowerCase().replace(/\s/g, '') === matchedModel?.variant_cmp_price_one
            ? matchedModel?.variant_cmp_pricetext_one
            : (EmiData?.vehiclePrice)?.toLowerCase().replace(/\s/g, '') === matchedModel?.variant_cmp_price_two
            ? matchedModel?.variant_cmp_pricetext_two
            : (EmiData?.vehiclePrice)?.toLowerCase().replace(/\s/g, '') === matchedModel?.variant_cmp_price_three
            ? matchedModel?.variant_cmp_pricetext_three
            : null}
        </p>
        <h4 className="f-price mb-0">{item?.selling_price ? formatCurrency(item?.selling_price) : "-"}</h4>
      </div>
    ))}
  </div>
)}
</div>

                  {calculationData?.transformedDataCopy?.length>3 &&  !Modelloading && 
                  <>
                         <div
                        onClick={() => handleScroll(-180)}
                        className="f-navButton leftButton"
                      ></div>
                         
                     
                      <div
                        onClick={() => handleScroll(180)}
                        className="f-navButton rightButton"
                      ></div>
                      </>
                  }
                    </div>
 
                    
                    {EmiData?.downpaymentDetails?.type==="percentage" ?
                    
                     (<div   className={`f-horizontalRow ${
                      !EmiData?.downpaymentDetails?.percentageConfig?.sliderSelection ? "desktop-flex" : "desktop-block"
                    }`}
                  >
                     
                       <div className="mb-[25px] ">
                       <label className="label-text">
                        {Constants.EMICALCULATOR.SELECT_DOWNPAYMENT}
                       </label>
                       {!EmiData?.downpaymentDetails?.percentageConfig?.sliderSelection===true  ? 
                    <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      flexWrap: "wrap",
                    }}
                  >
                    {EmiData?.downpaymentDetails?.percentageConfig?.selectorblocks?.map((item, i) => (
                      <div
                        key={i}
                        className={`f-selectBox ${calculationData.selectedDownpayment === item ? "selected" : ""}`}
                        onClick={() => {
                          const downpaymentPercentage = parseFloat(item); // Convert item to number
                          const downpaymentAmount = (downpaymentPercentage / 100) * (vechileCharges + calculationData?.selectVariant?.selling_price); // Calculate amount
                          setCaculationData((prev) => ({
                            ...prev,
                            selectedDownpayment: item,
                            downpaymentAmount, // Update state
                          }));
                        }}
                        role="button"
                        onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault(); // Prevent default scroll for space key
                          const downpaymentPercentage = parseFloat(item);
                          const downpaymentAmount =
                            (downpaymentPercentage / 100) *
                            (vechileCharges + calculationData?.selectVariant?.selling_price);
                          setCaculationData((prev) => ({
                            ...prev,
                            selectedDownpayment: item,
                            downpaymentAmount,
                          }));
                        }
                      }}
                      tabIndex={0}
                        aria-label="Select Downpayment"
                      >
                        <span>{item}</span>
                      </div>
                    ))}
                  </div>
                       :
                       
                 <div className=" pt-[25px] relative">
                 <div className="f-horizontalRow  max-sm:flex" >
                   <div
                    className="flex items-center relative min-w-[80%] md:min-w-[90%]"
                   >
                     <span className="pr-2 p-[0px] m-[0px] box-border ">
                       {EmiData?.downpaymentDetails?.percentageConfig?.selectorblocks[0]}%
                     </span>
                     {console.log(calculationData?.selectedDownpayment,"lllll")}
                     <input
                       className="w-full h-[2px] sliderinput relative"
                       id="downpayment"
                       name="downpayment"
                       type="range"
                       min={
                        EmiData?.downpaymentDetails?.percentageConfig?.selectorblocks[0]
                       }
                       max={EmiData?.downpaymentDetails?.percentageConfig?.selectorblocks?.at(-1)}
                      value={
                        calculationData?.selectedDownpayment
                                }
                                
                         onChange={(e) => {
                                  const downpaymentPercentage = parseFloat(e.target.value);
                                  const downpaymentsliderAmount = (downpaymentPercentage / 100) * (vechileCharges + calculationData?.selectVariant?.selling_price);
                              
                                  setCaculationData((prev) => ({
                                    ...prev,
                                    selectedDownpayment:e.target.value,
                                    downpaymentAmount: downpaymentsliderAmount
                                  }));
                                }}
                       style={{
                         "-webkit-appearance": "none",
                         background: "#636363",
                       }}
                       aria-label="Downpayment"
                     />

                     <div className="range-line3">
                       <span className="active-line3"></span>
                     </div>

                     <span className=" pl-2 p-[0px] m-[0px] box-border">
                     {EmiData?.downpaymentDetails?.percentageConfig?.selectorblocks?.at(-1)}%
                     </span>
                   </div>
                   <div></div>
                   <div className="f-selectBoxSlider">
                     <span>{calculationData?.selectedDownpayment}</span>
                   </div>
                 </div>
                 {/* <div className="flex justify-between text-[14px]">
                   <span>
                     {EmiData?.minDownpayment
                       ? EmiData?.minDownpayment
                       : 20}{" "}
                     %
                   </span>
                   <span>80%</span>
                 </div> */}
               </div>
                    }
                     </div>
                     <div
  className={`mb-[25px] ${
    EmiData?.downpaymentDetails?.percentageConfig?.selectorblocks?.length > 12
      ? "h-[100px]"
      : EmiData?.downpaymentDetails?.percentageConfig?.selectorblocks?.length > 6
      ? "h-[80px]"
      : "h-auto"
  }`}
>
  <InputField
    id="downpayment"
    style={{backgroundColor:"#eeeeee",fontSize:"18px"}}
    label={Constants.EMICALCULATOR.AMOUNT_TO_FINANCE}
    type="text"
    disabled={true}
    // value={((vechileCharges + calculationData?.selectVariant?.selling_price) - calculationData?.downpaymentAmount) ? formatCurrency((vechileCharges + calculationData?.selectVariant?.selling_price) - calculationData?.downpaymentAmount) : "--"} // Render calculated amount
    value={(calculationData.downpaymentAmount) ? formatCurrency(Math.round(calculationData.downpaymentAmount)) : "--"} // Render calculated amount
  />
</div>
                    </div>)
:
(
<div className="f-horizontalRow flex flex-col">
  <div className="mb-[25px] w-full">
    <InputField
     id="downpayment"
     label={Constants.EMICALCULATOR.AMOUNT}
     type="text"
     value={IsValidPrice(inputValue) ? inputValue : ""}// Bind input value to state
     onChange={(e) => {
    const value = e.target.value;

    // Allow user to type freely (only valid numbers & decimals)
    if (/^\d*\.?\d*$/.test(value)) {
      setInputValue(value);

      // Convert value to number
      const inputAmount = parseFloat(value);
      if (!isNaN(inputAmount)) {
        const downpaymentPercentage = (inputAmount / (vechileCharges + calculationData?.selectVariant?.selling_price)) * 100;

        // Validation check (allow typing but block state update)
        if (downpaymentPercentage >= EmiData?.downpaymentDetails?.amoutConfig?.selectorblocks[0] && downpaymentPercentage <= EmiData?.downpaymentDetails?.amoutConfig?.selectorblocks?.at(-1)) {
          setErrorMessage(""); // ✅ Remove error
          
          // ✅ Only update state if the value is valid
          setCaculationData((prev) => ({
            ...prev,
            downpaymentAmount: inputAmount,
            selectedDownpaymenamount: downpaymentPercentage.toFixed(2),
          }));
        } else {
          setErrorMessage(`${Constants.EMICALCULATOR.DOWNPAYMENT_ERROR_MSG_1} ${EmiData?.downpaymentDetails?.amoutConfig?.selectorblocks[0]}% ${Constants.EMICALCULATOR.DOWNPAYMENT_ERROR_MSG_2} ${EmiData?.downpaymentDetails?.amoutConfig?.selectorblocks?.at(-1)}% ${Constants.EMICALCULATOR.DOWNPAYMENT_ERROR_MSG_3}`);
        }
      }
    }
  }}
/>
{console.log(errorMessage,"errorMessage")}
   {errorMessage && <span className="text-red-500" style={{color:"red"}}>{errorMessage}</span>}
  </div>

 { EmiData?.downpaymentDetails?.amoutConfig?.showSlider===true && 
 <div className="pb-[25px] relative w-full">
  <div className="f-horizontalRow">
                            <div
                              className="flex items-center relative"
                              style={{ minWidth: "90%" }}
                            >
                              <span className="pr-2 p-[0px] m-[0px] box-border ">
                              {EmiData?.downpaymentDetails?.amoutConfig?.selectorblocks[0]}%
                              </span>
                              <input
                                className="w-full h-[2px] sliderinput relative"
                                id="downpayment"
                                name="downpayment"
                                type="range"
                                min={EmiData?.downpaymentDetails?.amoutConfig?.selectorblocks[0]}
                                max={EmiData?.downpaymentDetails?.amoutConfig?.selectorblocks?.at(-1)}
                                step="0.5" // ✅ Add step to allow decimal increments
                                value={
                                  calculationData.selectedDownpaymenamount
                                }
                                onChange={(e) =>{
                                  const downpaymentamount = parseFloat(e.target.value);
                                  const downpaymentamountAmount = (downpaymentamount / 100) * calculationData?.selectVariant?.selling_price;
                              
                                  
                                  setCaculationData((prev) => ({
                                    ...prev,
                                    selectedDownpaymenamount:e.target.value,
                                    downpaymentAmount: downpaymentamountAmount
                                  }));
                                  setErrorMessage(""); 
                                }}
                                style={{
                                  "-webkit-appearance": "none",
                                  background: `linear-gradient(to right, #007bff ${((calculationData.selectedDownpaymenamount - EmiData?.downpaymentDetails?.amoutConfig?.selectorblocks[0]) / (EmiData?.downpaymentDetails?.amoutConfig?.selectorblocks?.at(-1) - EmiData?.downpaymentDetails?.amoutConfig?.selectorblocks[0])) * 100}%, #C0C0C0 0%)`,
                                }}
                                aria-label="Downpayment"
                              />
 {/* <div className="range-line3" style={{ position: "relative", width: "100%" }}>
        <span
          className="active-line3"
          style={{
            position: "absolute",
            height: "100%",
            background: "#007bff", // ✅ Selected area color
            width: `${
              Math.min(
                Math.max(
                  ((calculationData.selectedDownpaymenamount - EmiData?.downpaymentDetails?.amoutConfig?.selectorblocks[0]) /
                    (EmiData?.downpaymentDetails?.amoutConfig?.selectorblocks.at(-1) -
                      EmiData?.downpaymentDetails?.amoutConfig?.selectorblocks[0])) *
                    100,
                  0
                ),
                100
              ) // ✅ Ensure the width stays within 0% to 100%
            }%`,
          }}
        ></span>
      </div> */}
                              <span className=" pl-2 p-[0px] m-[0px] box-border">
                              {EmiData?.downpaymentDetails?.amoutConfig?.selectorblocks?.at(-1)}%
                              </span>
                            </div>
                            <div></div>
                            <div className="f-selectBoxSlider">
                              <span>{calculationData.selectedDownpaymenamount}</span>
                            </div>
                          </div>

  
  </div>} 
</div>

)


                    }
                  
                    <div className="mb-[25px] ">
                      <label className="label-text">
                      {Constants.EMICALCULATOR.SELECT_MONTH}
                      </label>
                      <div
                        className=""
                        style={{
                          display: "flex",
                          gap: "10px",
                          flexWrap: "wrap",
                        }}
                      >
                        {!EmiData?.tenureDetails?.sliderSelection===true ?  
                        
                        EmiData?.tenureDetails?.selectorblocks?.map((e,i)=>(
                          <div
                          key={i}
                          className={`f-selectBox ${calculationData.selectedTenure === e ? "selected" : ""}`}
                          onClick={() => {
                            setCaculationData((prev) => ({
                              ...prev,
                              selectedTenure: e,
                            }));
                          }}
                          role='button'
                          onKeyDown={(event) => {
                            if (event.key === "Enter" || event.key === " ") {
                              event.preventDefault();
                              setCaculationData((prev) => ({
                                ...prev,
                                selectedTenure: e,
                              }));
                            }
                          }}
                          tabIndex={0}
                          aria-label="Tenure"
                        >
                          <span>{e}</span>
                        </div>
                           ))
:
<div className="pt-[25px] relative w-full">
<div className="f-horizontalRow">
  <div className="flex items-center justify-between pl-[4px] sm:pr-[0px] pr-[40px] w-full">
    <span className="text-sm text-[#001151] font-medium mr-2 ">
      {EmiData?.tenureDetails?.selectorblocks[0]}
    </span>
    <div className="flex items-center relative" style={{ minWidth: "88%" }}>
    <input
      className="w-full h-[2px] relative cursor-pointer
        appearance-none rounded-full  
        [&::-webkit-slider-runnable-track]:rounded-full
        [&::-webkit-slider-thumb]:appearance-none 
        [&::-webkit-slider-thumb]:w-4 [&::-webkit-slider-thumb]:h-4 
        [&::-webkit-slider-thumb]:bg-white 
        [&::-webkit-slider-thumb]:rounded-full 
        [&::-webkit-slider-thumb]:border [&::-webkit-slider-thumb]:border-[#001151]
        [&::-webkit-slider-thumb]:shadow-md"
      id="downpayment"
      name="downpayment"
      type="range"
      min={EmiData?.tenureDetails?.selectorblocks[0]}
      max={EmiData?.tenureDetails?.selectorblocks?.at(-1)}
      step={EmiData?.tenureDetails?.tenureGap}
      value={calculationData?.selectedTenure}
      onChange={(e) => {
        const inputValue = parseFloat(e.target.value); // Use parseFloat for decimals if needed
        const validSteps = EmiData?.tenureDetails?.selectorblocks?.map(Number); // Ensure numbers
      
        if (validSteps.includes(inputValue)) {
         setCaculationData((prev) => ({
            ...prev,
            selectedTenure: inputValue,
          })); 
        } else {
          console.log("Invalid step:", inputValue);
          // Optional: Reset or handle if inputValue is not valid
        }
      }}
      
      style={{
        WebkitAppearance: "none",
        background: `linear-gradient(to right, #001151 0%, #001151  
          ${parseFloat(((calculationData?.selectedTenure - EmiData?.tenureDetails?.selectorblocks[0]) / 
          (EmiData?.tenureDetails?.selectorblocks?.at(-1) - EmiData?.tenureDetails?.selectorblocks[0])) * 100).toFixed(2)}%, 
          #DBDBDB ${parseFloat(((calculationData?.selectedTenure - EmiData?.tenureDetails?.selectorblocks[0]) / 
          (EmiData?.tenureDetails?.selectorblocks?.at(-1) - EmiData?.tenureDetails?.selectorblocks[0])) * 100).toFixed(2)}%, 
          #DBDBDB 100%)`,
        borderRadius: "2px",
        position: "relative",
      }}
      aria-label="Tenure"
    />

    <div className="absolute top-1/2 left-0 right-0 h-[2px] pointer-events-none">
      {EmiData?.tenureDetails?.selectorblocks.map((value, index, arr) => {
        const min = arr[0];
        const max = arr[arr.length - 1];

        // if (value === min || value === max) return null; // Exclude first & last

        return (
          <div
            key={index}
            className="absolute h-[10px] w-[2px] bg-black"
            style={{
              left: `${((value - min) / (max - min)) * 100}%`,
              transform: "translateX(-50%) translateY(-50%)",
            }}
          />
        );
      })}
    </div>

  </div>
  <span className="text-sm text-[#001151] font-medium mr-7 ml-2">
      {EmiData?.tenureDetails?.selectorblocks?.at(-1)}
    </span>
  </div>

 

  <div className="f-selectBoxSlider text-center">
    <span className="text-base font-semibold">
      {calculationData?.selectedTenure}
    </span>
  </div>
</div>
</div>

                      }
                         
                      </div>
                    </div>



                    
                  {EmiData?.interestSelection?.showintrest && <div className="mb-[25px] ">
                    <label className="label-text">
                     {Constants.EMICALCULATOR.SELECT_INTREST_RATE}
                    </label>


                    {!EmiData?.interestSelection?.intrestConfig?.sliderSelection === true ?
                      <div
                      className=""
                      style={{
                        display: "flex",
                        gap: "10px",
                        flexWrap: "wrap",
                      }}
                    >
                      {EmiData?.interestSelection?.intrestConfig?.selectorblocks?.map((e,i)=>(
                    <div
                    key={i}
                    className={`f-selectBox ${calculationData.selectedInterest === e ? "selected" : ""}`}
                    onClick={() => {
                      setCaculationData((prev) => ({
                        ...prev,
                        selectedInterest: e,
                      }));
                    }}
                    role="button"
                     onKeyDown={(event) => {
                      if (event.key === "Enter" || event.key === " ") {
                        event.preventDefault();
                        setCaculationData((prev) => ({
                          ...prev,
                          selectedInterest: e,
                        }));
                      }
                    }}
                    tabIndex={0}
                    aria-label="Interest Rate"
                  >
                    <span>{e}</span>
                  </div>
                      ))}
                    </div>

                    :

                    <div className="pt-[25px] relative w-full">
                    <div className="f-horizontalRow">
                      <div className="flex items-center justify-between  pl-[4px] sm:pr-[0px] pr-[50px] w-full">
                        <span className="text-sm text-[#001151] font-medium mr-2">
                          {EmiData?.interestSelection?.intrestConfig?.selectorblocks[0]}
                        </span>
                        <div className="flex items-center relative" style={{ minWidth: "88%" }}>
                        <input
                          className="w-full h-[2px] relative cursor-pointer
                            appearance-none rounded-full  
                            [&::-webkit-slider-runnable-track]:rounded-full
                            [&::-webkit-slider-thumb]:appearance-none 
                            [&::-webkit-slider-thumb]:w-4 [&::-webkit-slider-thumb]:h-4 
                            [&::-webkit-slider-thumb]:bg-white 
                            [&::-webkit-slider-thumb]:rounded-full 
                            [&::-webkit-slider-thumb]:border [&::-webkit-slider-thumb]:border-[#001151]
                            [&::-webkit-slider-thumb]:shadow-md"
                          id="downpayment"
                          name="downpayment"
                          type="range"
                          min={EmiData?.interestSelection?.intrestConfig?.selectorblocks[0]}
                          max={EmiData?.interestSelection?.intrestConfig?.selectorblocks?.at(-1)}
                          step={EmiData?.interestSelection?.intrestConfig?.intrestgap}
                          value={calculationData?.selectedInterest}
                          onChange={(e) => {
                            const inputValue = parseFloat(e.target.value); // Keep decimal support
                            const validSteps = EmiData?.interestSelection?.intrestConfig?.selectorblocks.map(Number);
                          
                            // Check if the inputValue exactly matches a step
                            if (validSteps.includes(inputValue)) {
                              setCaculationData((prev) => ({
                                ...prev,
                                selectedInterest: inputValue,
                              }));
                            } else {
                              console.log("Invalid step: ", inputValue);
                              // Optionally, you can reset it or do nothing
                            }
                          }}
                          style={{
                            WebkitAppearance: "none",
                            background: `linear-gradient(to right, #001151 0%, #001151  
                              ${parseFloat(((calculationData?.selectedInterest - EmiData?.interestSelection?.intrestConfig?.selectorblocks[0]) / 
                              (EmiData?.interestSelection?.intrestConfig?.selectorblocks?.at(-1) - EmiData?.interestSelection?.intrestConfig?.selectorblocks[0])) * 100).toFixed(2)}%, 
                              #DBDBDB ${parseFloat(((calculationData?.selectedInterest - EmiData?.tenureDetails?.selectorblocks[0]) / 
                              (EmiData?.interestSelection?.intrestConfig?.selectorblocks?.at(-1) - EmiData?.interestSelection?.intrestConfig?.selectorblocks[0])) * 100).toFixed(2)}%, 
                              #DBDBDB 100%)`,
                            borderRadius: "2px",
                            position: "relative",
                          }}
                          aria-label="Interest Rate"
                        />
                    
                        <div className="absolute top-1/2 left-0 right-0 h-[2px] pointer-events-none">
                          {EmiData?.interestSelection?.intrestConfig?.selectorblocks.map((value, index, arr) => {
                            const min = arr[0];
                            const max = arr[arr.length - 1];
                    
                            // if (value === min || value === max) return null; // Exclude first & last
                    
                            return (
                              <div
                                key={index}
                                className="absolute h-[10px] w-[2px] bg-black"
                                style={{
                                  left: `${((value - min) / (max - min)) * 100}%`,
                                  transform: "translateX(-50%) translateY(-50%)",
                                }}
                              />
                            );
                          })}
                        </div>
                    
                      </div>
                      <span className="text-sm text-[#001151] font-medium mr-6 ml-3">
                          {EmiData?.interestSelection?.intrestConfig?.selectorblocks?.at(-1)}
                        </span>
                      </div>
                    
                    
                    
                      <div className="f-selectBoxSlider text-center">
                        <span className="text-base font-semibold">
                          {calculationData?.selectedInterest}
                        </span>
                      </div>
                    </div>
                    </div>
                  }
                    
                  </div>}


                    {EmiData?.Interest_to_be_shown && 
                    <div
                    className={`mb-[25px]
                      }`}
                   >
                  <InputField
                    id="downpayment"
                    label={Constants.EMICALCULATOR.INTREST_RATE}
                    type="text"
                    disabled={true}
                    value={calculationData?.selectedInterest} // Render calculated amount
                  />
                  </div>
                    }
                    

                    {EmiData?.City_to_be_shown && 
                      <div className="mb-[25px]">
                      <SearchableDropdown
                        id="city"
                        label="name"
                        // disabled={EmiData?.intrestRateProvided ? false : true}
                        label2="Select City"
                        options={cityinfo}
                        selectedVal={selectedCity}
                        handleChange={setselectedCity}
                        calculationData={calculationData}
                        setCaculationData={setCaculationData}
                        placeholder={Constants.EMICALCULATOR.SELECT_CITY}
                      />
                    </div>
                    }

                    {/* vechile charge conditions */}
                  {process.env.NEXT_PUBLIC_COUNTRY_CODE == "MEX" ?
                    <>
                     {EmiData?.isvehicleAdditionalCondition &&
                        EmiData?.vehicleAdditionalChargeCondition &&
                        EmiData?.vehicleAdditionalChargeCondition.map(
                            (item, index) => {
                              return (
                                  <div className="mb-[25px]" key={index}>
                                    <SelectInput
                                        id="selectedcondition"
                                        label={item?.title}
                                        items={item?.condition}
                                        placeholder={Constants.EMICALCULATOR.SELECT_METHOD}
                                        onChange={(e) => {
                                          const selectedValue = e.target.value;
                                          if (selectedValue) {
                                            const parsedValue = JSON.parse(selectedValue);
                                            const methodName = parsedValue.methodName;
                                
                                            // Calculate total amount
                                            
                                            setFinalEmi(0);
                                
                                            // Update selectedMethods array at the specific index
                                            setselectedvechileCondition((prevMethods) => {
                                              const updatedMethods = [...prevMethods];
                                              updatedMethods[index] = { label: item?.title, value: parsedValue };
                                              return updatedMethods;
                                            });
                                          } else {
                                            // If selection is cleared, remove the entry at the specific index
                                            setselectedvechileCondition((prevMethods) => {
                                              const updatedMethods = [...prevMethods];
                                              updatedMethods.splice(index, 1);
                                              return updatedMethods;
                                            });
                                            setFinalEmi(0);
                                          }
                                        }}
                                    />
                                  </div>
                              );
                            }
                          )
                          } 
                    </>
                  :
                  
                  <>
                  {EmiData?.isvehicleAdditionalCondition ? (
                    EmiData?.vehicleAdditionalChargeCondition?.map((e, i) => {
                      return (
                        <div className="mb-[25px]" key={i}>
                          <SelectInput
                            id="selectedvehicleCharge"
                            label={e?.title}
                            items={e?.condition}
                            placeholder={Constants.EMICALCULATOR.SELECT}
                            onChange={(ev) => {
                              const selectedValue = ev.target.value;
                
                              if (selectedValue) {
                                const selected = JSON.parse(selectedValue);
                                console.log("Selected:", selected);
                
                                // ✅ Update calculationData
                                if (selected?.methodValue) {
                                  setCaculationData((prev) => ({
                                    ...prev,
                                    vechileTaxs: {
                                      ...prev.vechileTaxs,
                                      [e.title]: {
                                        [selected.methodName]: selected.methodValue,
                                      },
                                    },
                                  }));
                
                                  // ✅ Store selected value (like in `if` block)
                                  setselectedvechileCondition((prevMethods) => {
                                    const updated = [...prevMethods];
                                    updated[i] = { label: e?.title, value: selected };
                                    return updated;
                                  });
                
                                  setselectedVariant("");
                                }
                              } else {
                                // ❌ Reset if nothing is selected
                                setCaculationData((prev) => ({
                                  ...prev,
                                  defaultModel: "",
                                  // taxdetails: [],
                                }));
                
                                // ❌ Also clear selected value
                                setselectedvechileCondition((prevMethods) => {
                                  const updated = [...prevMethods];
                                  updated.splice(i, 1);
                                  return updated;
                                });
                
                                setselectedVariant("");
                              }
                            }}
                          />
                        </div>
                      );
                    })
                  ) : (
                    ""
                  )}
                </>
                
                  }
                


                    {/* downpayment charge conditions */}

                    {process.env.NEXT_PUBLIC_COUNTRY_CODE == "MEX" ?
                    <>
                     {EmiData?.isDownpaymentCondition &&
                        EmiData?.downpaymentAdditionalChargeCondition &&
                        EmiData?.downpaymentAdditionalChargeCondition.map(
                            (item, index) => {
                              return (
                                  <div className="mb-[25px]" key={index}>
                                    <SelectInput
                                        id="selectedcondition"
                                        label={item?.title}
                                        items={item?.condition}
                                        placeholder={Constants.EMICALCULATOR.SELECT_METHOD}
                                        onChange={(e) => {
                                          const selectedValue = e.target.value;
                                          if (selectedValue) {
                                            console.log(selectedValue,"tttttttuuuuu")
                                            const parsedValue = JSON.parse(selectedValue);
                                            const methodName = parsedValue.methodName;
                                
                                            // Calculate total amount
                                            const totalAmount = (vechileCharges + calculationData?.selectVariant?.selling_price) - calculationData?.downpaymentAmount;
                                console.log(totalAmount,"trtrtrtrtrt",vechileCharges,calculationData?.selectVariant?.selling_price,calculationData?.downpaymentAmount)
                                            // Update credit amounts based on methodName
                                            if (methodName === "Cash" || methodName === "cash" || methodName === "De contado") {
                                              setfincanceCreditAmount(0);
                                              setcashCreditAmount(totalAmount);
                                            } else if (methodName === "Finance" || methodName === "Financed" || methodName === "Financiado" || methodName === "Funded") {
                                              setcashCreditAmount(0);
                                              setfincanceCreditAmount(totalAmount);
                                            }
                                
                                            // setFinalEmi(0);
                                
                                            // Update selectedMethods array at the specific index
                                            setselectedMethods((prevMethods) => {
                                              const updatedMethods = [...prevMethods];
                                              updatedMethods[index] = { label: item?.title, value: parsedValue };
                                              return updatedMethods;
                                            });
                                          } else {
                                            // If selection is cleared, remove the entry at the specific index
                                            setselectedMethods((prevMethods) => {
                                              const updatedMethods = [...prevMethods];
                                              updatedMethods.splice(index, 1);
                                              return updatedMethods;
                                            });
                                            // setFinalEmi(0);
                                          }
                                        }}
                                    />
                                  </div>
                              );
                            }
                          )
                          } 
                    </>
:
<>
  {EmiData?.isDownpaymentCondition ? (
    EmiData?.downpaymentAdditionalChargeCondition?.map((e, i) => {
      return (
        <div className="mb-[25px]" key={i}>
          <SelectInput
            id="selectedDownpaymentCharge"
            label={e?.title}
            items={e?.condition}
            placeholder={Constants.EMICALCULATOR.SELECT}
            onChange={(ev) => {
              const selectedValue = ev.target.value;

              if (selectedValue) {
                const selected = JSON.parse(selectedValue);
                const methodName = selected.methodName;
                const methodValue = selected.methodValue;

                const totalAmount =
                  (vechileCharges + calculationData?.selectVariant?.selling_price) -
                  calculationData?.downpaymentAmount;

                // ✅ Set cash or finance amount
                if (
                  methodName === "Cash" ||
                  methodName === "cash" ||
                  methodName === "De contado"
                ) {
                  setfincanceCreditAmount(0);
                  setcashCreditAmount(totalAmount);
                  
                } else if (
                  methodName === "Finance" ||
                  methodName === "Financed" ||
                  methodName === "Financiado" ||
                  methodName === "Funded"
                ) {
                  setcashCreditAmount(0);
                  setfincanceCreditAmount(totalAmount);
                }

                // setFinalEmi(0);

                // ✅ Update selectedMethods like in MEX
                setselectedMethods((prevMethods) => {
                  const updated = [...prevMethods];
                  updated[i] = { label: e?.title, value: selected };
                  return updated;
                });

                // ✅ Update calculationData.downpaymentTax
                if (methodValue) {
                  setCaculationData((prev) => ({
                    ...prev,
                    downpaymentTax: {
                      ...prev.downpaymentTax,
                      [e.title]: {
                        [methodName]: methodValue,
                      },
                    },
                  }));
                }
              } else {
                // ❌ Reset state when nothing is selected
                setfincanceCreditAmount(0);
                setcashCreditAmount(0);
                // setFinalEmi(0);

                setselectedMethods((prevMethods) => {
                  const updated = [...prevMethods];
                  updated.splice(i, 1);
                  return updated;
                });

                setCaculationData((prev) => ({
                  ...prev,
                  defaultModel: "",
                  // taxdetails: [],
                }));

                setselectedVariant("");
              }
            }}
          />
        </div>
      );
    })
  ) : (
    ""
  )}
</>

}                
                
                    <div className=" hidden lg:block flex justify-center">
                      <div className="lg:w-[640px] w-[354px] flex lg:flex-row flex-col lg:gap-[22px] gap-[10px]">
                      {EmiData?.ctasettings && EmiData?.ctasettings[0] && (
                        EmiData?.ctasettings?.[0]?.ctatype === "Primary" ? (
                          <div className="lg:w-1/3">
                            <div className="compareItem__CTAs">
                              {EmiData?.ctasettings?.[0]?.ctaaction === "Link"  ? 
                               <LinkButton
                               type={"primary_grad_button"}
                               href={EmiData?.ctasettings[0]?.link}
                               target={EmiData?.ctasettings[0]?.selecttarget === "Same Tab" ? "_self": "_blank"}
                               buttontext={EmiData?.ctasettings[0]?.ctatitle}
                               classname="button_dark_arrow"
                                
                             />
                             :
                             
                          //    <CardLinkFunc
                          //    formToBeSelected={EmiData?.ctasettings[0]?.selectform}
                          //    cardBtnText={Constants.expericencIcon.BOOK_A_TEST_DRIVE}
                          //    iconImage={`${configuration.IMG_STATIC_URL}test_Drive_form.svg`}
                          //  />
                          <LinkButton
                          type={"primary_grad_button"}
                          onClick={() => {
                                            dispatch(toggleForm(EmiData?.ctasettings[0]?.selectform));
                                          }}
                           buttontext={EmiData?.ctasettings[0]?.ctatitle}
                          classname="button_dark_arrow"
                          iconImage={`${configuration.IMG_STATIC_URL}test_Drive_form.svg`}
                        />
                              }
                             
                            </div>
                          </div>
                        ) : EmiData?.ctasettings[0]?.ctatype === "Tertiary" ? (
                          
                          <div className="lg:w-1/3" style={{display:"flex",alignItems:"flex-end"}}>
                            <div className="">
                            {EmiData?.ctasettings[0]?.ctaaction === "Link"  ? 
                               <LinkButton
                               type={"tertiary_button"}
                               href={EmiData?.ctasettings[0]?.link}
                               target={EmiData?.ctasettings[0]?.selecttarget === "Same Tab" ? "_self": "_blank"}
                               buttontext={EmiData?.ctasettings[0]?.ctatitle}
                             />
                             :
                             <LinkButton
                             type={"tertiary_button"}
                             onClick={() => {
                                               dispatch(toggleForm(EmiData?.ctasettings[0]?.selectform));
                                             }}
                             buttontext={EmiData?.ctasettings[0]?.ctatitle}
                            //  iconImage={`${configuration.IMG_STATIC_URL}test_Drive_form.svg`}
                           />
                              }
                            </div>
                          </div>
                        ) : (
                          <div className="lg:w-1/3">
                          <div className="compareItem__CTAs">
                          {EmiData?.ctasettings[0]?.ctaaction === "Link"  ? 
                               <LinkButton
                               type={"secondary_grad_button"}
                               href={EmiData?.ctasettings[0]?.link}
                               target={EmiData?.ctasettings[0]?.selecttarget === "Same Tab" ? "_self": "_blank"}
                               buttontext={EmiData?.ctasettings[0]?.ctatitle}
                             />
                             :
                             <LinkButton
                             type={"secondary_grad_button"}
                             onClick={() => {
                                               dispatch(toggleForm(EmiData?.ctasettings[0]?.selectform));
                                             }}
                             buttontext={EmiData?.ctasettings[0]?.ctatitle}
                             iconImage={`${configuration.IMG_STATIC_URL}test_Drive_form.svg`}
                           />
                              }
                        </div>
                        </div>
                        )
                      )}
                           {EmiData?.ctasettings && EmiData?.ctasettings?.[1] && (
                        EmiData?.ctasettings?.[1]?.ctatype === "Primary" ? (
                          <div className="lg:w-1/3">
                            <div className="compareItem__CTAs">
                              {EmiData?.ctasettings[1]?.ctaaction === "Link"  ? 
                               <LinkButton
                               type={"primary_grad_button"}
                               href={EmiData?.ctasettings[1]?.link}
                               target={EmiData?.ctasettings[1]?.selecttarget === "Same Tab" ? "_self": "_blank"}
                               buttontext={EmiData?.ctasettings[1]?.ctatitle}
                               classname="button_dark_arrow"
                                
                             />
                             :
                             <LinkButton
                             type={"primary_grad_button"}
                             onClick={() => {
                                               dispatch(toggleForm(EmiData?.ctasettings[1]?.selectform));
                                             }}
                            buttontext={EmiData?.ctasettings[1]?.ctatitle}
                             classname="button_dark_arrow"
                             iconImage={`${configuration.IMG_STATIC_URL}test_Drive_form.svg`}
                           />
                              }
                             
                            </div>
                          </div>
                        ) : EmiData?.ctasettings[1]?.ctatype === "Tertiary" ? (
                          
                          <div className="lg:w-1/3" style={{display:"flex",alignItems:"flex-end"}}>
                            <div className="">
                            {EmiData?.ctasettings[1]?.ctaaction === "Link"  ? 
                               <LinkButton
                               type={"tertiary_button"}
                               href={EmiData?.ctasettings[1]?.link}
                               target={EmiData?.ctasettings[1]?.selecttarget === "Same Tab" ? "_self": "_blank"}
                               buttontext={EmiData?.ctasettings[1]?.ctatitle}
                             />
                             :
                             <LinkButton
                             type={"tertiary_button"}
                             onClick={() => {
                                               dispatch(toggleForm(EmiData?.ctasettings[1]?.selectform));
                                             }}
                             buttontext={EmiData?.ctasettings[1]?.ctatitle}
                             iconImage={`${configuration.IMG_STATIC_URL}test_Drive_form.svg`}
                           />
                              }
                            </div>
                          </div>
                        ) : (
                          <div className="lg:w-1/3">
                          <div className="compareItem__CTAs">
                          {EmiData?.ctasettings[1]?.ctaaction === "Link"  ? 
                               <LinkButton
                               type={"secondary_grad_button"}
                               href={EmiData?.ctasettings[1]?.link}
                               target={EmiData?.ctasettings[1]?.selecttarget === "Same Tab" ? "_self": "_blank"}
                               buttontext={EmiData?.ctasettings[1]?.ctatitle} 
                             />
                             :
                             <LinkButton
                             type={"secondary_grad_button"}
                             onClick={() => {
                                               dispatch(toggleForm(EmiData?.ctasettings[1]?.selectform));
                                             }}
                             buttontext={EmiData?.ctasettings[1]?.ctatitle}
                             iconImage={`${configuration.IMG_STATIC_URL}test_Drive_form.svg`}
                           />
                              }
                        </div>
                        </div>
                        )
                      )}
                           {EmiData?.ctasettings && EmiData?.ctasettings?.[2] && (
                        EmiData?.ctasettings?.[2]?.ctatype === "Primary" ? (
                          <div className="lg:w-1/3">
                            <div className="compareItem__CTAs">
                              {EmiData?.ctasettings[2]?.ctaaction === "Link"  ? 
                               <LinkButton
                               type={"primary_grad_button"}
                               href={EmiData?.ctasettings[2]?.link}
                               target={EmiData?.ctasettings[2]?.selecttarget === "Same Tab" ? "_self": "_blank"}
                               buttontext={EmiData?.ctasettings[2]?.ctatitle}
                               classname="button_dark_arrow"
                                
                             />
                             :
                             <LinkButton
                             type={"primary_grad_button"}
                             onClick={() => {
                                               dispatch(toggleForm(EmiData?.ctasettings[2]?.selectform));
                                             }}
                             buttontext={EmiData?.ctasettings[2]?.ctatitle}
                             classname="button_dark_arrow"
                             iconImage={`${configuration.IMG_STATIC_URL}test_Drive_form.svg`}
                           />
                              }
                             
                            </div>
                          </div>
                        ) : EmiData?.ctasettings[2]?.ctatype === "Tertiary" ? (
                          
                          <div className="lg:w-1/3" style={{display:"flex",alignItems:"flex-end"}}>
                            <div className="">
                            {EmiData?.ctasettings[2]?.ctaaction === "Link"  ? 
                               <LinkButton
                               type={"tertiary_button"}
                               href={EmiData?.ctasettings[2]?.link}
                               target={EmiData?.ctasettings[2]?.selecttarget === "Same Tab" ? "_self": "_blank"}
                               buttontext={EmiData?.ctasettings[2]?.ctatitle}
                             />
                             :
                             <LinkButton
                             type={"tertiary_button"}
                             onClick={() => {
                                               dispatch(toggleForm(EmiData?.ctasettings[2]?.selectform));
                                             }}
                             buttontext={Constants.expericencIcon.BOOK_A_TEST_DRIVE}
                             iconImage={`${configuration.IMG_STATIC_URL}test_Drive_form.svg`}
                           />
                              }
                            </div>
                          </div>
                        ) : (
                          <div className="lg:w-1/3">
                          <div className="compareItem__CTAs">
                          {EmiData?.ctasettings[2]?.ctaaction === "Link"  ? 
                               <LinkButton
                               type={"secondary_grad_button"}
                               href={EmiData?.ctasettings[2]?.link}
                               target={EmiData?.ctasettings[2]?.selecttarget === "Same Tab" ? "_self": "_blank"}
                               buttontext={EmiData?.ctasettings[2]?.ctatitle} 
                             />
                             :
                             <LinkButton
                             type={"secondary_grad_button"}
                             onClick={() => {
                                               dispatch(toggleForm(EmiData?.ctasettings[2]?.selectform));
                                             }}
                             buttontext={EmiData?.ctasettings[2]?.ctatitle}
                             iconImage={`${configuration.IMG_STATIC_URL}test_Drive_form.svg`}
                           />
                              }
                        </div>
                        </div>
                        )
                      )}
                      </div>
                    </div>
                    <div className=" lg:hidden flex justify-center">
                      <div className="flex justify-center mb-[50px] lg:mb-[100px]">
                        <Button className="font-suzukiBold text-inverted uppercase border-[1px] border-[#001151] w-[171px] h-[40px] bg-[#001151] text-[13px]"  onClick={handleScrollToEmi}>
                          {Constants.EMICALCULATOR.CALCULATE_BTN}
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="f-boxRight">
                  <div className="f-carDetails">
                  <div ref={emiRef}>
                    <h3 className={`mb-0 leading-[1] ${
                        process.env.NEXT_PUBLIC_COUNTRY_CODE == 'PH'
                          ? 'f-carDetails__heading_PH'
                          : 'f-carDetails__heading'
                      }`}>
                      {calculationData?.defaultModelName} {calculationData?.selectVariant?.variant_name}
                    </h3>
                     {process.env.NEXT_PUBLIC_COUNTRY_CODE !== 'PH' && 
                    <p className="f-carDetails__description mt-2">
                    {matchedModel && (EmiData?.vehiclePrice)?.toLowerCase().replace(/\s/g, '') === matchedModel?.variant_cmp_price_one
                      ? matchedModel?.variant_cmp_pricetext_one
                      : (EmiData?.vehiclePrice)?.toLowerCase().replace(/\s/g, '') === matchedModel?.variant_cmp_price_two
                      ? matchedModel?.variant_cmp_pricetext_two
                      : (EmiData?.vehiclePrice)?.toLowerCase().replace(/\s/g, '') === matchedModel?.variant_cmp_price_three
                      ? matchedModel?.variant_cmp_pricetext_three
                      : null}
                    </p>
                     }
                 {process.env.NEXT_PUBLIC_COUNTRY_CODE !== 'PH' && <span className="font-suzukiBold text-[24px]">{(calculationData?.selectVariant?.selling_price) ?formatCurrency(calculationData?.selectVariant?.selling_price) : "--"}</span>}
                    <div>
                       {process.env.NEXT_PUBLIC_COUNTRY_CODE !== 'PH' &&
                    <p className="f-carDetails__description mb-1 mt-5">
                    {Constants.EMICALCULATOR.INDICATIVE_EMI_AMOUNT}
                    </p>
                     }
                    <p className={`f-carDetails_price  ${process.env.NEXT_PUBLIC_COUNTRY_CODE === 'PH'?"setfontsize_PH":"setfontsize"}`}>
                      <span className={`font-suzukiBold ${
                        process.env.NEXT_PUBLIC_COUNTRY_CODE === 'PH'
                          ? 'gapBottom-ph'
                          : 'gapBottom'
                      }`}>
            {
  (finalEmi &&
    calculationData?.selectVariant?.selling_price &&
    IsValidPrice(finalEmi))
    ? formatCurrency(
        (finalEmi % 10 >= 6)
          ? Math.ceil(finalEmi / 10) * 10
          : Math.floor(finalEmi / 10) * 10
      )
    : "--"
}
</span> /
                      <span className="font-suzukiRegular">{Constants.EMICALCULATOR.MONTH}</span>
                    </p>
                    </div>
                    </div>

                        {!EmiData?.isvehicleAdditionalCondition ? 
                        
                        EmiData?.vehicleAdditionalCharge?.map(
                              (item, index) => {
                                return (
                                    <>
                                    <div className="flex justify-between">
                                     <p className="flex justify-between mt-1 mb-1" key={index}>
                                        {item?.value}
                                        </p>
                                        <p className="flex justify-between mt-1 mb-1" key={item?.value}>
                                          {calculationData?.selectVariant?.taxChargeDetails && calculationData?.selectVariant?.taxChargeDetails?.length > 0 ? (
                                            calculationData?.selectVariant?.taxChargeDetails?.map((taxdata) => {
                                              if (item?.type === taxdata?.taxChargeType) {
                                                return taxdata?.valueType === 1
                                                  ? IsValidPrice(
                                                      (calculationData?.selectVariant?.selling_price * taxdata?.value) / 100
                                                    )
                                                    ? formatCurrency(
                                                        (calculationData?.selectVariant?.selling_price * taxdata?.value) / 100
                                                      )
                                                    : "--"
                                                  : IsValidPrice(taxdata?.value)
                                                  ? formatCurrency(taxdata?.value)
                                                  : "--";
                                              }
                                              return null;
                                            })
                                          ) : (
                                            "--"
                                          )}
                                        </p>
                                    </div>
                                    </>
                                );
                              },
                          )
                        : 
                        selectedvechileCondition &&
                        selectedvechileCondition.map((item, index) => {
                         return (
                             <>
                               <div className=" font-suzukiBold flex">
                                 {`${item?.label} : ${item?.value?.methodName}`}
                               </div>
                                
                               {item?.value?.methodValue?.map(
                                   (val, index) => {
                                     return (
                                         <>
                                         <div className="flex justify-between mt-3 flex">
                                           <p className=" " key={index}>
                                             {val.value}
                                           </p>
                                           <p
                                               className="text-right"
                                               key={val?.value}
                                           >
                                             {calculationData?.selectVariant?.taxChargeDetails &&
                                                 calculationData?.selectVariant?.taxChargeDetails?.map(
                                                     (taxdata) => {
                                                       if (
                                                           val?.type ==
                                                           taxdata?.taxChargeType
                                                       )
                                                         return taxdata?.valueType == 1
                                                             ? IsValidPrice((calculationData?.selectVariant?.selling_price *
                                                               taxdata?.value) /
                                                           100)?formatCurrency(
                                                                 (calculationData?.selectVariant?.selling_price *
                                                                     taxdata?.value) /
                                                                 100,
                                                             ):"--"
                                                             : IsValidPrice(taxdata?.value)?formatCurrency(
                                                                 taxdata?.value,
                                                             ):"--";
                                                     },
                                                 )}
                                           </p>
                                           </div>
                                         </>
                                     );
                                   },
                               )}
                             </>
                         );
                       })

                        }

{/* <p className="flex font-suzukiBold justify-between mt-3 mb-4">
  <span>{Constants.EMICALCULATOR.TOTAL_PRICE}</span>
  <span> {IsValidPrice(vechileCharges + calculationData?.selectVariant?.selling_price)?formatCurrency(vechileCharges + calculationData?.selectVariant?.selling_price):"--"}</span>
</p>


<p className="flex font-suzukiBold justify-between mt-3 mb-3">
  <span>{Constants.EMICALCULATOR.DOWNPAYMENT}</span>
  <span>{(calculationData.downpaymentAmount) ? formatCurrency(calculationData.downpaymentAmount) : "--"}</span>
</p> */}
{process.env.NEXT_PUBLIC_COUNTRY_CODE !== 'PH' ?
<p className="flex font-suzukiBold justify-between mt-3 mb-10">
  <span>{Constants.EMICALCULATOR.LOAN_AMOUNT}</span>
  <span>
  {
  process.env.NEXT_PUBLIC_COUNTRY_CODE === "MEX" ? (
    IsValidPrice(
      cashCreditAmount
        ? cashCreditAmount
        : financeCreditAmount + DownpaymentCharges + 900
    )
      ? formatCurrency(
        Math.round(
          cashCreditAmount
            ? cashCreditAmount
            : financeCreditAmount + DownpaymentCharges + 900
        )
        )
      : "--"
  ) : (
    IsValidPrice(
      (vechileCharges + calculationData?.selectVariant?.selling_price) -
      calculationData?.downpaymentAmount
    )
      ? formatCurrency(
          Math.round(
          (vechileCharges + calculationData?.selectVariant?.selling_price) -
          calculationData?.downpaymentAmount
          )
        )
      : "--"
  )
}
</span>
</p>
:
<p className="flex justify-between mb-10 text-[16px]">
  {
  process.env.NEXT_PUBLIC_COUNTRY_CODE === "MEX" ? (
    IsValidPrice(
      cashCreditAmount
        ? cashCreditAmount
        : financeCreditAmount + DownpaymentCharges + 900
    )
      ? formatCurrency(
          Math.round(
          cashCreditAmount
            ? cashCreditAmount
            : financeCreditAmount + DownpaymentCharges + 900
          )
        )
      : "--"
  ) : (
    IsValidPrice(
      (vechileCharges + calculationData?.selectVariant?.selling_price) -
      calculationData?.downpaymentAmount
    )
      ? formatCurrency(
          Math.round(
          (vechileCharges + calculationData?.selectVariant?.selling_price) -
          calculationData?.downpaymentAmount
          )
        )
      : "--"
  )
}
   &nbsp;   &nbsp;
  {Constants.EMICALCULATOR.LOAN_AMOUNT} 
</p>
 }

 
                  {!EmiData?.isDownpaymentCondition
                              ? EmiData?.downpaymentAdditionalCharge?.map(
                                  (item, index) => {
                                    return (
                                        <>
                                        <div className="flex justify-between">
                                          <p className="" key={index}>
                                            {item?.value}
                                          </p>
                                          <p className="text-right" key={item?.value}>
                                            {calculationData?.selectVariant?.taxChargeDetails &&
                                                calculationData?.selectVariant?.taxChargeDetails?.map((taxdata) => {
                                                  if (
                                                      item?.type == taxdata?.taxChargeType
                                                  )
                                                    return taxdata?.valueType == 1
                                                        ? IsValidPrice((calculationData?.selectVariant?.selling_price *
                                                          taxdata?.value) /
                                                      100)? formatCurrency(
                                                            (calculationData?.selectVariant?.selling_price *
                                                                taxdata?.value) /
                                                            100,
                                                        ):"--"
                                                        : IsValidPrice(taxdata?.value)? formatCurrency(taxdata?.value):"--";
                                                })}
                                          </p>
                                          </div>
                                        </>
                                    );
                                  },
                              )
                              :
                               selectedMethods &&
                               selectedMethods.map((item, index) => {
                                return (
                                    <>
                                      <div className=" font-suzukiBold flex">
                                        {`${item?.label} : ${item?.value?.methodName}`}
                                      </div>
                                       
                                      {item?.value?.methodValue?.map(
                                          (val, index) => {
                                            return (
                                                <>
                                                <div className="flex justify-between mt-3">
                                                  <p className=" " key={index}>
                                                    {val.value}
                                                  </p>
                                                  <p
                                                      className="text-right"
                                                      key={val?.value}
                                                  >
                                                    {calculationData?.selectVariant?.taxChargeDetails &&
                                                       calculationData?.selectVariant?.taxChargeDetails?.map(
                                                            (taxdata) => {
                                                              if (
                                                                  val?.type ==
                                                                  taxdata?.taxChargeType
                                                              )
                                                                return taxdata?.valueType == 1
                                                                    ? IsValidPrice((calculationData?.selectVariant?.selling_price *
                                                                      taxdata?.value) /
                                                                  100)?formatCurrency(
                                                                        (calculationData?.selectVariant?.selling_price *
                                                                            taxdata?.value) /
                                                                        100,
                                                                    ):"--"
                                                                    : IsValidPrice(taxdata?.value)?formatCurrency(
                                                                        taxdata?.value,
                                                                    ):"--";
                                                            },
                                                        )}
                                                  </p>
                                                  </div>
                                                </>
                                            );
                                          },
                                      )}
                                    </>
                                );
                              })
                              }


  {process.env.NEXT_PUBLIC_COUNTRY_CODE == "MEX" &&   
                     <p className="flex justify-between mt-3 mb-10">
                          <span className="">
                            {Constants.EMICALCULATOR?.INTITAL_BANK_COMMISION}
                          </span>
                          <span className="text-right">
                            {IsValidPrice(roadtax)?formatCurrency(roadtax):"--"}
                          </span>
                          </p>
}

{process.env.NEXT_PUBLIC_COUNTRY_CODE !== 'PH' &&  <p className="flex font-suzukiBold justify-between mt-3 mb-10 flex">
  <span>{Constants.EMICALCULATOR.INITIAL_PAYMENT_AMOUNT}</span>
  {console.log(DownpaymentCharges, calculationData?.downpaymentAmount, DownpaymentCharges + calculationData?.downpaymentAmount,roadtax,"xx",formatCurrency(DownpaymentCharges + calculationData?.downpaymentAmount)>0)}
  <span>
  {
  process.env.NEXT_PUBLIC_COUNTRY_CODE === "MEX" ? (
    IsValidPrice(cashCreditAmount
      ? DownpaymentCharges + calculationData?.downpaymentAmount + roadtax + 900
      : calculationData?.downpaymentAmount + roadtax
    )
      ? formatCurrency(
          cashCreditAmount
            ? DownpaymentCharges + calculationData?.downpaymentAmount + roadtax + 900
            : calculationData?.downpaymentAmount + roadtax
        )
      : "--"
  ) : (
    IsValidPrice(DownpaymentCharges + calculationData?.downpaymentAmount)
      ? formatCurrency(DownpaymentCharges + calculationData?.downpaymentAmount)
      : IsValidPrice(calculationData?.downpaymentAmount)
        ? formatCurrency(calculationData?.downpaymentAmount)
        : "--"
  )
}
</span>
</p>}

 {(EmiData?.disclaimer?.isdisclaimershow && process.env.NEXT_PUBLIC_COUNTRY_CODE == 'PH') &&  <p className="f-carDetails__description text-align-left mb-0">
                          <span className="text-medium">{Constants.EMICALCULATOR.DESCLIAMER}</span>
                          <span
                            dangerouslySetInnerHTML={{
                              __html: EmiData?.disclaimer?.disclaimertext || '',
                            }}
                          />
                        </p>}


{/* <p className="flex font-suzukiBold justify-between mt-3 mb-10">
  <span>{Constants.EMICALCULATOR.LOAN_AMOUNT}</span>
  <span>
  {
  process.env.NEXT_PUBLIC_COUNTRY_CODE === "MEX" ? (
    IsValidPrice(
      cashCreditAmount
        ? cashCreditAmount
        : financeCreditAmount + DownpaymentCharges + 900
    )
      ? formatCurrency(
          cashCreditAmount
            ? cashCreditAmount
            : financeCreditAmount + DownpaymentCharges + 900
        )
      : "--"
  ) : (
    IsValidPrice(
      (vechileCharges + calculationData?.selectVariant?.selling_price) -
      calculationData?.downpaymentAmount
    )
      ? formatCurrency(
          (vechileCharges + calculationData?.selectVariant?.selling_price) -
          calculationData?.downpaymentAmount
        )
      : "--"
  )
}
</span>
</p> */}





                       
                    <div className="f-bannerImg">
                      <Image
                        src={configuration.IMG_URL + ((calculationData?.selectVariant?.colors?.find((color) => color.is_default === true)?.image) || (calculationData?.selectVariant?.colors?.[0]?.image))}
                        layout="fill"
                        objectFit="contain"
                        alt="model_variant"
                      />
                    </div>
                    {(EmiData?.disclaimer?.isdisclaimershow && process.env.NEXT_PUBLIC_COUNTRY_CODE !== 'PH') &&  <p className="f-carDetails__description text-align-left mb-0" >
                          <span className="text-medium">{Constants.EMICALCULATOR.DESCLIAMER}</span>
                          <span
                            className="disclaimer-margin"
                            dangerouslySetInnerHTML={{
                              __html: EmiData?.disclaimer?.disclaimertext || '',
                            }}
                          />
                        </p>
                     } 
                  </div>
                </div>
                <div className=" lg:hidden flex justify-center mt-10">
                  <div className="lg:w-[640px] w-[354px] flex lg:flex-row flex-col lg:gap-[22px] gap-[10px]">
                  {EmiData?.ctasettings?.[0] && (
                        EmiData?.ctasettings[0]?.ctatype === "Primary" ? (
                          <div className="lg:w-1/3">
                            <div className="compareItem__CTAs">
                              {EmiData?.ctasettings[0]?.ctaaction === "Link"  ? 
                               <LinkButton
                               type={"primary_grad_button"}
                               href={EmiData?.ctasettings[0]?.link}
                               target={EmiData?.ctasettings[0]?.selecttarget === "Same Tab" ? "_self": "_blank"}
                               buttontext={EmiData?.ctasettings[0]?.ctatitle}
                               classname="button_dark_arrow"
                                
                             />
                             :
                             <LinkButton
                             type={"primary_grad_button"}
                             onClick={() => {
                                               dispatch(toggleForm("test_drive_form"));
                                             }}
                             buttontext={EmiData?.ctasettings[0]?.ctatitle}
                             classname="button_dark_arrow"
                             iconImage={`${configuration.IMG_STATIC_URL}test_Drive_form.svg`}
                           />
                              }
                             
                            </div>
                          </div>
                        ) : EmiData?.ctasettings[0]?.ctatype === "Tertiary" ? (
                          
                          <div className="lg:w-1/3 pl-[87px]">
                            <div className="">
                            {EmiData?.ctasettings[0]?.ctaaction === "Link"  ? 
                               <LinkButton
                               type={"tertiary_button"}
                               href={EmiData?.ctasettings[0]?.link}
                               target={EmiData?.ctasettings[0]?.selecttarget === "Same Tab" ? "_self": "_blank"}
                               buttontext={EmiData?.ctasettings[0]?.ctatitle}
                             />
                             :
                             <LinkButton
                             type={"tertiary_button"}
                             onClick={() => {
                                               dispatch(toggleForm(EmiData?.ctasettings[0]?.selectform));
                                             }}
                             buttontext={EmiData?.ctasettings[0]?.ctatitle}
                            //  iconImage={`${configuration.IMG_STATIC_URL}test_Drive_form.svg`}
                           />
                              }
                            </div>
                          </div>
                        ) : (
                          <div className="lg:w-1/3">
                          <div className="compareItem__CTAs">
                          {EmiData?.ctasettings[0]?.ctaaction === "Link"  ? 
                               <LinkButton
                               type={"secondary_grad_button"}
                               href={EmiData?.ctasettings[0]?.link}
                               target={EmiData?.ctasettings[0]?.selecttarget === "Same Tab" ? "_self": "_blank"}
                               buttontext={EmiData?.ctasettings[0]?.ctatitle} 
                             />
                             :
                             <LinkButton
                             type={"secondary_grad_button"}
                             onClick={() => {
                                               dispatch(toggleForm(EmiData?.ctasettings[0]?.selectform));
                                             }}
                             buttontext={EmiData?.ctasettings[0]?.ctatitle}
                             iconImage={`${configuration.IMG_STATIC_URL}test_Drive_form.svg`}
                           />
                              }
                        </div>
                        </div>
                        )
                      )}
                           {EmiData?.ctasettings?.[1] && (
                        EmiData?.ctasettings?.[1]?.ctatype === "Primary" ? (
                          <div className="lg:w-1/3">
                            <div className="compareItem__CTAs">
                              {EmiData?.ctasettings[1]?.ctaaction === "Link"  ? 
                               <LinkButton
                               type={"primary_grad_button"}
                               href={EmiData?.ctasettings[1]?.link}
                               target={EmiData?.ctasettings[1]?.selecttarget === "Same Tab" ? "_self": "_blank"}
                               buttontext={EmiData?.ctasettings[1]?.ctatitle}
                               classname="button_dark_arrow"
                                
                             />
                             :
                             <LinkButton
                             type={"primary_grad_button"}
                             onClick={() => {
                                               dispatch(toggleForm(EmiData?.ctasettings[1]?.selectform));
                                             }}
                             buttontext={EmiData?.ctasettings[1]?.ctatitle}
                             classname="button_dark_arrow"
                             iconImage={`${configuration.IMG_STATIC_URL}test_Drive_form.svg`}
                           />
                              }
                             
                            </div>
                          </div>
                        ) : EmiData?.ctasettings[1]?.ctatype === "Tertiary" ? (
                          
                          <div className="lg:w-1/3 pl-[87px]">
                            <div className="">
                            {EmiData?.ctasettings[1]?.ctaaction === "Link"  ? 
                               <LinkButton
                               type={"tertiary_button"}
                               href={EmiData?.ctasettings[1]?.link}
                               target={EmiData?.ctasettings[1]?.selecttarget === "Same Tab" ? "_self": "_blank"}
                               buttontext={EmiData?.ctasettings[1]?.ctatitle}
                             />
                             :
                             <LinkButton
                             type={"tertiary_button"}
                             onClick={() => {
                                               dispatch(toggleForm(EmiData?.ctasettings[1]?.selectform));
                                             }}
                             buttontext={EmiData?.ctasettings[1]?.ctatitle}
                             iconImage={`${configuration.IMG_STATIC_URL}test_Drive_form.svg`}
                           />
                              }
                            </div>
                          </div>
                        ) : (
                          <div className="lg:w-1/3 ">
                          <div className="compareItem__CTAs">
                          {EmiData?.ctasettings[1]?.ctaaction === "Link"  ? 
                               <LinkButton
                               type={"secondary_grad_button"}
                               href={EmiData?.ctasettings[1]?.link}
                               target={EmiData?.ctasettings[1]?.selecttarget === "Same Tab" ? "_self": "_blank"}
                               buttontext={EmiData?.ctasettings[1]?.ctatitle} 
                             />
                             :
                             <LinkButton
                             type={"secondary_grad_button"}
                             onClick={() => {
                                               dispatch(toggleForm(EmiData?.ctasettings[1]?.selectform));
                                             }}
                             buttontext={EmiData?.ctasettings[1]?.ctatitle}
                             iconImage={`${configuration.IMG_STATIC_URL}test_Drive_form.svg`}
                           />
                              }
                        </div>
                        </div>
                        )
                      )}
                           {EmiData?.ctasettings?.[2] && (
                        EmiData?.ctasettings?.[2]?.ctatype === "Primary" ? (
                          <div className="lg:w-1/3">
                            <div className="compareItem__CTAs">
                              {EmiData?.ctasettings[2]?.ctaaction === "Link"  ? 
                               <LinkButton
                               type={"primary_grad_button"}
                               href={EmiData?.ctasettings[2]?.link}
                               target={EmiData?.ctasettings[2]?.selecttarget === "Same Tab" ? "_self": "_blank"}
                               buttontext={EmiData?.ctasettings[2]?.ctatitle}
                               classname="button_dark_arrow"
                                
                             />
                             :
                             <LinkButton
                             type={"primary_grad_button"}
                             onClick={() => {
                                               dispatch(toggleForm(EmiData?.ctasettings[2]?.selectform));
                                             }}
                             buttontext={EmiData?.ctasettings[2]?.ctatitle}
                             classname="button_dark_arrow"
                             iconImage={`${configuration.IMG_STATIC_URL}test_Drive_form.svg`}
                           />
                              }
                             
                            </div>
                          </div>
                        ) : EmiData?.ctasettings[2]?.ctatype === "Tertiary" ? (
                          
                          <div className="lg:w-1/3 pl-[87px]">
                            <div className="">
                            {EmiData?.ctasettings[2]?.ctaaction === "Link"  ? 
                               <LinkButton
                               type={"tertiary_button"}
                               href={EmiData?.ctasettings[2]?.link}
                               target={EmiData?.ctasettings[2]?.selecttarget === "Same Tab" ? "_self": "_blank"}
                               buttontext={EmiData?.ctasettings[2]?.ctatitle}
                             />
                             :
                             <LinkButton
                             type={"tertiary_button"}
                             onClick={() => {
                                               dispatch(toggleForm(EmiData?.ctasettings[2]?.selectform));
                                             }}
                             buttontext={EmiData?.ctasettings[2]?.ctatitle}
                             iconImage={`${configuration.IMG_STATIC_URL}test_Drive_form.svg`}
                           />
                              }
                            </div>
                          </div>
                        ) : (
                          <div className="lg:w-1/3">
                          <div className="compareItem__CTAs">
                          {EmiData?.ctasettings[2]?.ctaaction === "Link"  ? 
                               <LinkButton
                               type={"secondary_grad_button"}
                               href={EmiData?.ctasettings[2]?.link}
                               target={EmiData?.ctasettings[2]?.selecttarget === "Same Tab" ? "_self": "_blank"}
                               buttontext={EmiData?.ctasettings[2]?.ctatitle} 
                             />
                             :
                             <LinkButton
                             type={"secondary_grad_button"}
                             onClick={() => {
                                               dispatch(toggleForm(EmiData?.ctasettings[2]?.selectform));
                                             }}
                             buttontext={EmiData?.ctasettings[2]?.ctatitle}
                             iconImage={`${configuration.IMG_STATIC_URL}test_Drive_form.svg`}
                           />
                              }
                        </div>
                        </div>
                        )
                      )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default EmiCalculator;
